const CryptoJS = require('crypto-js');
const passphrase = 'safeopozeeeeeeee';
const CBC_MARKER = '6362633a'; // "cbc:" in hex

const encryptWithAES = (text) => {
  const key = CryptoJS.enc.Utf8.parse(passphrase);
  const iv = CryptoJS.lib.WordArray.random(16);
  const encrypted = CryptoJS.AES.encrypt(text, key, {mode: CryptoJS.mode.CBC, iv: iv, padding: CryptoJS.pad.Pkcs7});
  const marker = CryptoJS.enc.Utf8.parse('cbc:');
  const combined = marker.concat(iv).concat(encrypted.ciphertext);
  return CryptoJS.enc.Base64.stringify(combined);
};

const decryptWithAES = (ciphertext) => {
  const key = CryptoJS.enc.Utf8.parse(passphrase);
  const raw = CryptoJS.enc.Base64.parse(ciphertext);
  const rawHex = CryptoJS.enc.Hex.stringify(raw);

  if (rawHex.startsWith(CBC_MARKER)) {
    // CBC format: "cbc:" (4 bytes) + IV (16 bytes) + ciphertext
    const ivHex = rawHex.substring(8, 40);
    const ctHex = rawHex.substring(40);
    const iv = CryptoJS.enc.Hex.parse(ivHex);
    const ct = CryptoJS.enc.Hex.parse(ctHex);
    const decrypted = CryptoJS.AES.decrypt({ciphertext: ct}, key, {mode: CryptoJS.mode.CBC, iv: iv, padding: CryptoJS.pad.Pkcs7});
    return decrypted.toString(CryptoJS.enc.Utf8);
  }

  // Legacy ECB fallback
  const bytes = CryptoJS.AES.decrypt(ciphertext, key, {mode: CryptoJS.mode.ECB});
  return bytes.toString(CryptoJS.enc.Utf8);
};

export default {
    encryptWithAES,
    decryptWithAES
}
